import { Modal } from "antd";
import NewTable from "components/NewTable";
import HeaderTable from "components/Page/HeaderTable";
import useUnidadeComPessoas from "core/features/unidades/useUnidadesComPessoas";
import FooterModal from "ui/components/Button/FooterModal";
import useFiltroConsultarPessoasEUnidades from "./hooks/useFiltroConsultarPessoasEUnidades";
import usePessoasEUnidadesColumns from "./hooks/usePessoasEUnidadesColumns";
import { Box, Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import colors from "core/resources/theme/colors";
import { useEffect } from "react";

interface ModalConsultarPessoasEUnidadesProps {
  visible: boolean;
  onClose: () => any;
}

function ModalConsultarPessoasEUnidades({
  visible,
  onClose,
}: ModalConsultarPessoasEUnidadesProps) {
  const { filtro, onChangeFiltro, resetFiltro } =
    useFiltroConsultarPessoasEUnidades();
  const { data, isLoading, isFetching } = useUnidadeComPessoas(filtro, visible);
  const columns = usePessoasEUnidadesColumns();

  useEffect(() => {
    if (!visible) {
      resetFiltro();
    }
  }, [resetFiltro, visible]);

  return (
    <Modal
      destroyOnClose
      width="900px"
      title="Consultar pessoas e unidades"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onClose={onClose}
          showRegisterAnother={false}
          buttonCancelarText={"Fechar"}
        />
      }
      centered
      bodyStyle={{
        height: "fit-content",
        overflow: "auto",
      }}
      visible={visible}
      onCancel={onClose}
    >
      <Box marginTop={-4}>
        <NewTable
          title={() => (
            <HeaderTable
              value={filtro.search ?? ""}
              onSearch={(search) => onChangeFiltro({ search })}
              childrenFlex={0}
              searchMinW="350px"
              searchPlaceholder="Busca por nome, unidade ou celular"
              children={
                <Flex gap={3} flex={1}>
                  <SelectableButton
                    selected={
                      filtro.pessoaAtivo === 1 ||
                      filtro.pessoaAtivo === undefined
                    }
                    onClick={() => {
                      onChangeFiltro({ pessoaAtivo: 1 });
                    }}
                    onUnselect={() => {
                      onChangeFiltro({ pessoaAtivo: undefined });
                    }}
                    rounded="full"
                    selectedColor={colors.green500}
                  >
                    Ativos
                  </SelectableButton>

                  <SelectableButton
                    selected={filtro.pessoaAtivo === 0}
                    onClick={() => {
                      onChangeFiltro({ pessoaAtivo: 0 });
                    }}
                    onUnselect={() => {
                      onChangeFiltro({ pessoaAtivo: undefined });
                    }}
                    rounded="full"
                    selectedColor={colors.red500}
                  >
                    Inativos
                  </SelectableButton>
                </Flex>
              }
            />
          )}
          loading={isLoading || isFetching}
          rowKey={(record) => record.pessoaId}
          columns={columns}
          dataSource={data?.items || []}
          customPagination={{
            currentPage: data?.meta?.currentPage ?? 1,
            totalItems: data?.meta?.totalItems ?? data?.items?.length,
            itemsPerPage: data?.meta?.itemsPerPage ?? data?.items?.length,
            onChangePage: (page, limit) => onChangeFiltro({ page, limit }),
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                window.open(
                  `/cadastros/unidades/${record.unidadeId}?opcao=pessoas&highlight=${record.pessoaId}`
                );
              },
              style: {
                cursor: "pointer",
              },
            };
          }}
        />
      </Box>
    </Modal>
  );
}

export default ModalConsultarPessoasEUnidades;
